@if (foot()) {
<div class="foot">
    @for (item of foot().items; track item._id) {
    <div class="dynamic">
        <ng-container [dynamic]="item"></ng-container>
    </div>
    }
</div>
}
